import { z } from 'zod'
import { EndDate, IsActive, StartDate, UpdateDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace ObjectLevel {
  export interface Data {
    /** @description Unique record identifier. Key field. Object level number. */
    readonly level: number

    /** @description Name */
    readonly name: string

    /** @description Short name */
    readonly shortName?: string

    /** @description Record entry (update) date */
    readonly updateDate: Date

    /** @description Record validity start */
    readonly startDate: Date

    /** @description Record validity end */
    readonly endDate: Date

    /** @description Active object level indicator */
    readonly isActive: boolean
  }
}

/** @description Information on the address object level */
export class ObjectLevel extends GarItem<'ObjectLevel', ObjectLevel.Data> {
  static readonly SCHEMA: GarItem.Schema<ObjectLevel.Data> = z
    .strictObject({
      LEVEL: z.coerce
        .number<string>()
        .int()
        .describe('Unique record identifier. Key field. Object level number.'),

      NAME: z.string().describe('Name'),

      SHORTNAME: z.string().optional().describe('Short name'),

      UPDATEDATE: UpdateDate,

      STARTDATE: StartDate,

      ENDDATE: EndDate,

      ISACTIVE: IsActive,
    })
    .transform<ObjectLevel.Data>(attributes => ({
      level: attributes.LEVEL,
      name: attributes.NAME,
      shortName: attributes.SHORTNAME,
      updateDate: attributes.UPDATEDATE,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
      isActive: attributes.ISACTIVE,
    }))

  readonly type = 'ObjectLevel'

  protected get schema() {
    return ObjectLevel.SCHEMA
  }
}
